;(function(document, window, $, undefined) {

	if ($('#news-filter').length) {

		$('#news-filter')
			.on('change', function(e){
				window.location = $(this).find('option:selected').val();
			});

	}

})(document, window, jQuery);